import Insight from './insight'

class InsightTime extends Insight {
  get date() {
    return new Date(this.data?.x)
  }
}

export default InsightTime
